"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.fileList = exports.updateStatus = exports.statusList = exports.dataInterface = void 0;
var data_1 = require("../../../interface/user-management/user/data");
var DataSuperAdmin = __importStar(require("../../../interface/user-management/user/superadmin"));
exports.dataInterface = function (uuid, withBackend) { return ({
    list: DataSuperAdmin.list({ uuid: uuid }, withBackend),
    detail: DataSuperAdmin.detail({ uuid: uuid }, withBackend),
    insert: DataSuperAdmin.insert({ uuid: uuid }, withBackend),
    update: DataSuperAdmin.update({ uuid: uuid }, withBackend),
    deleteById: DataSuperAdmin.deleteById({ uuid: uuid }, withBackend)
}); };
exports.statusList = data_1.statusList();
exports.updateStatus = DataSuperAdmin.statusUpdate;
exports.fileList = function (uuid) { return Promise.resolve([]); };
